import React, { useEffect, useState } from 'react';
import { onToast } from '@/Utils/toastManager';

function Toast({ toast, onClose }) {
    const bg = toast.type === 'error' ? 'bg-red-600' : toast.type === 'success' ? 'bg-green-600' : 'bg-blue-600';

    useEffect(() => {
        const t = setTimeout(() => onClose(), toast.duration || 4000);
        return () => clearTimeout(t);
    }, [toast, onClose]);

    return (
        <div className={`rounded-md px-3 py-2 text-white shadow ${bg}`}
             role="status" aria-live="polite">
            {toast.message}
        </div>
    );
}

export default function GlobalToasts() {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        const unsub = onToast((t) => {
            const id = Date.now() + Math.random();
            const toast = { id, ...t };
            setToasts((prev) => [...prev, toast]);
        });

        return () => unsub();
    }, []);

    const remove = (id) => setToasts((prev) => prev.filter((t) => t.id !== id));

    return (
        <div className="fixed right-4 top-4 z-50 flex flex-col gap-3">
            {toasts.map((t) => (
                <Toast key={t.id} toast={t} onClose={() => remove(t.id)} />
            ))}
        </div>
    );
}
